import { render, staticRenderFns } from "./FormCollection.vue?vue&type=template&id=127f4a86&scoped=true&"
import script from "./FormCollection.vue?vue&type=script&lang=js&"
export * from "./FormCollection.vue?vue&type=script&lang=js&"
import style0 from "./FormCollection.vue?vue&type=style&index=0&id=127f4a86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f4a86",
  null
  
)

export default component.exports